import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions, useQuery, useQueryClient } from "@tanstack/react-query";

import { useMutationWithError } from "@/hooks";
import { adminApi } from "@/lib/api";

import { type NotificationTemplate } from "../types";

export const notificationTemplates = createQueryKeys(
  "admin-notification-template",
  {
    all: null,
  },
);

export const fetchNotificationTemplatesQueryOptions = () =>
  queryOptions({
    ...notificationTemplates.all,
    queryFn: () =>
      adminApi
        .get<NotificationTemplate[]>("notification-templates", {
          params: {},
        })
        .then((response) => response.data),
  });

export const useFetchNotificationTemplates = () =>
  useQuery(fetchNotificationTemplatesQueryOptions());

export interface NotificationTemplatesRequest {
  templates: {
    id: number;
    title?: string | null;
    content: string;
  }[];
}

export const useUpdateNotificationTemplates = () => {
  const queryClient = useQueryClient();
  return useMutationWithError({
    mutationFn: (data: NotificationTemplatesRequest) =>
      adminApi
        .put(`notification-templates/bulk`, data)
        .then((response) => response.data),
    onSuccess: () => {
      return queryClient.invalidateQueries(notificationTemplates.all);
    },
  });
};

export const useUpdateNotificationTemplateStatus = () => {
  const queryClient = useQueryClient();
  return useMutationWithError({
    mutationFn: ({ id, is_enabled }: { id: number; is_enabled: boolean }) =>
      adminApi
        .put(`notification-templates/${id}`, { is_enabled })
        .then((response) => response.data),
    onSuccess: () => {
      return queryClient.invalidateQueries(notificationTemplates.all);
    },
  });
};
